import React from 'react';

export class Alert extends React.PureComponent {
    renderErrorAlert() {
        return (<div className="alert alert-danger">
                    <span>
                        <strong>Se produjo un error en la b&uacute;squeda :(</strong> Int&eacute;ntelo nuevamente m&aacute;s tarde
                    </span>
                </div>);
    }

    render() {
        if (this.props.error) {
            return (
                <div className="searchResultSummary">
                    <div className="col-md-12">
                        {this.renderErrorAlert()}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ../components/Alert/Alert.jsx